export default "__VITE_ASSET__DFZKixH3__"